import {Component, HostBinding, Input, OnDestroy, OnInit} from "@angular/core";
import {FUINavigationService} from "../navigation.service";
import {Subscription} from "rxjs";
import {FUINavigationLink, FUINavigationLinkAvailability} from "../navigation-link/navigation-link.model";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
    animations: [
        trigger("toggle", [
            state("void", style({
                height: 0,
                "margin-bottom": 0,
                "margin-top": 0,
                opacity: 0,
                overflow: "hidden",
                "padding-bottom": 0,
                "padding-top": 0
            })),
            state("true", style({})),
            transition("* => *", animate("250ms 0s ease"))
        ])
    ],
    selector: "fui-navigation-group",
    templateUrl: "./navigation-group.component.html",
    styleUrls: ["./navigation-group.component.scss"]
})
export class FUINavigationGroupComponent implements OnInit, OnDestroy {
    FUINavigationLinkAvailability = FUINavigationLinkAvailability;

    public isOpen: boolean;
    @Input() group: FUINavigationLink;
    private linkSubscription: Subscription;
    private groupSubscription: Subscription;

    @HostBinding("class.mobile") private get mobile() {
        return this.navigationService.useMobileNav();
    };

    constructor(public navigationService: FUINavigationService) {
    }

    ngOnInit() {
        this.linkSubscription = this.navigationService.activeLink$.subscribe((activeLink) => {
            if (this.group.links.find(link => activeLink === link)) {
                this.navigationService.setActiveGroup(this.group);
            } else {
                setTimeout(() => {
                    this.isOpen = false;
                });
            }
        });

        this.groupSubscription = this.navigationService.activeGroup$.subscribe((activeGroup) => {
            if (activeGroup === this.group) {
                setTimeout(() => {
                    this.isOpen = true;
                });
            } else {
                setTimeout(() => {
                    this.isOpen = false;
                });
            }
        });
    }

    ngOnDestroy(): void {
        this.linkSubscription.unsubscribe();
        this.groupSubscription.unsubscribe();
    }

    /**
     * Toggle state of the accordion and let other
     * segments know it has been opened or closed
     */
    toggleOpen(): void {
        this.isOpen = !this.isOpen;
    }
}
